<template>
  <div id="publicClass_pay">
    <div class="bottombox">
      <Header ref="header" />
    </div>
    <!-- bottombox end -->
    <div class="hotgkt_bj">
      <div class="order_Steps">
        <div class="ul">
          <div class="stepsT">
            <strong
              ><span class="left"></span><span class="right"></span
            ></strong>
          </div>
          <div class="li" :class="{ side: side1 }">订单确认</div>
          <div class="li" :class="{ side: side2 }">订单支付</div>
          <div class="li" :class="{ side: side3 }">购买成功</div>
        </div>
      </div>
      <!-- order_Steps end -->
      <div class="order_content">
        <div class="order_xx">
          <h2>订单提交成功！</h2>
          <p class="p1">订单号：{{ Orders }}</p>
          <p class="p2">
            请在<span>{{ min }}分钟{{ sec }}秒</span
            >内完成此订单支付，否则订单将会自动取消
          </p>
          <p class="p3">订单金额：￥{{ money }}</p>
          <p class="p4">选择支付方式</p>
        </div>
        <!-- order_xx end -->
        <div class="order_zf">
          <ul class="clearfix">
            <li :class="{ radio1: radio1 }">
              <label>
                <el-radio
                  v-model="radio"
                  label="1"
                  @change="changeD"
                ></el-radio>
                <img src="../../assets/publicClass/zfb.png" />
              </label>
            </li>
            <li :class="{ radio1: radio2 }">
              <label>
                <el-radio
                  v-model="radio"
                  label="2"
                  @change="changeD"
                ></el-radio>
                <img src="../../assets/publicClass/wxzf.png" />
              </label>
            </li>
          </ul>
        </div>
        <!-- order_zf end -->
      </div>
      <!-- order_content end -->
    </div>
    <!-- hotgkt_bj end -->
    <div class="pay_tan" v-if="pay_tan">
      <div class="close" @click="closePay">
        <img src="../../assets/login/close.png" />
      </div>
      <div class="pay_smzf" v-if="radio1">
        <div class="p1">支付宝扫码支付</div>
        <div class="p2">使用支付宝APP扫码支付</div>
        <div class="p3"><img :src="zfbCodeImg" width="300" /></div>
        <div class="p4">打开手机支付宝，扫一扫继续付款</div>
      </div>
      <div class="pay_smzf" v-else>
        <div class="p1">微信扫码支付</div>
        <div class="p2">使用微信APP扫码支付</div>
        <div class="p3"><img :src="wxCodeImg" width="300" /></div>
        <div class="p4">打开手机微信，扫一扫继续付款</div>
      </div>
    </div>
  </div>
</template>

<script>
// import times from '../djs/time.vue'
import Header from "../../components/header/Header.vue"; //公共头部
export default {
  name: "publicClass_pay",
  components: {
    // 将组件隐射为标签,登陆弹窗
    Header
  },
  data() {
    return {
      side1: true,
      side2: true,
      side3: false,
      checked: false,
      radio: "",
      radio1: "",
      radio2: "",
      pay_tan: false,
      money: "",
      Orders: "",
      OrderTime: 0,
      sec: "",
      min: "",
      hr: "",
      day: "",
      wxCodeImg: "",
      zfbCodeImg: "",
      dataText: "",
      timer: ""
    };
  },
  //离开页面时清除请求接口的定时器
  beforeDestroy: function() {
    clearInterval(this.timer);
  },
  //离开页面后
  destroyed: function() {
    clearInterval(this.timer);
  },
  methods: {
    //页面支付
    changeD() {
      let that = this;
      this.pay_tan = true;
      // if(that.money==0){

      // }
      if (this.radio == "1") {
        this.radio1 = true;
        that.$http
          .get(
            "https://schoolapi.eiceducation.com.cn/api/CourseOrder?orderNum=" +
              that.Orders +
              "&type=1&payType=60&clents=2",
            {
              headers: {
                token: that.$cookies.get("token")
              }
            }
          )
          .then(function(response) {
            if (response.data.code == 200) {
              // console.log(response)
              that.zfbCodeImg = response.data.results;
            }
          })
          .catch(function() {
            // console.log('数据错误');
          });
      } else {
        this.radio1 = false;
      }
      // 微信
      if (this.radio == "2") {
        this.radio2 = true;
        that.$http
          .get(
            "https://schoolapi.eiceducation.com.cn/api/CourseOrder?orderNum=" +
              that.Orders +
              "&type=1&payType=61&clents=2",
            {
              headers: {
                token: that.$cookies.get("token")
              }
            }
          )
          .then(function(response) {
            if (response.data.code == 200) {
              // console.log(response)
              that.wxCodeImg = response.data.results;
            }
          })
          .catch(function() {
            // console.log('数据错误');
          });
      } else {
        this.radio2 = false;
      }
    },
    closePay() {
      this.pay_tan = false;
      this.radio = "";
      this.radio1 = false;
      this.radio2 = false;
    },
    //倒计时
    countdown() {
      const that = this;
      var date = new Date(that.OrderTime);
      var time1 = date.getTime();
      const end = time1 + 1800000;
      const now = Date.parse(new Date());
      const msec = end - now;
      if (msec < 0) return;
      let day = parseInt(msec / 1000 / 60 / 60 / 24);
      let hr = parseInt((msec / 1000 / 60 / 60) % 24);
      let min = parseInt((msec / 1000 / 60) % 60);
      let sec = parseInt((msec / 1000) % 60);
      this.day = day;
      this.hr = hr > 9 ? hr : "0" + hr;
      this.min = min > 9 ? min : "0" + min;
      this.sec = sec > 9 ? sec : "0" + sec;
      if (min >= 0 && sec >= 0) {
        if (min == 0 && sec == 0) {
          //倒计时结束关闭订单（支付失败）
          that.$router.push({ path: "/publicClass_failure" });
          clearInterval(that.timer);
          // 取消订单
          this.$http
            .delete(
              "https://schoolapi.eiceducation.com.cn/api/Order?orderNumber=" +
                that.Orders,
              {
                headers: {
                  token: that.$cookies.get("token")
                }
              }
            )
            .then(function(response) {
              //// console.log(response)
            })
            .catch(function(error) {
              // console.log(error);
            });
          return;
        }
        setTimeout(function() {
          that.countdown();
        }, 1000);
      }
    },
    //支付返回接口
    OrderCallBack() {
      let that = this;
      that.$http
        .get(
          "https://schoolapi.eiceducation.com.cn/api/OrderCallBack/" +
            that.Orders,
          {
            headers: {
              token: that.$cookies.get("token")
            }
          }
        )
        .then(function(response) {
          //支付成功跳转成功页面
          if (response.data.results && response.data.results.Status === 2) {
            clearInterval(that.timer);
            that.$router.push({ path: "/publicClass_success" });
            localStorage.setItem("Money", response.data.results.Money);
          }
        })
        .catch(function(err) {
          // console.log(err)
          // console.log('数据错误');
        });
    }
  },
  mounted: function() {
    //自动触发写入的函数
    let that = this;
    if (!this.$cookies.isKey("token")) {
      this.$router.push("/index");
    }
    that.money = this.$route.query.moneytext;
    that.Orders = this.$route.query.Orderstext;
    // that.OrderTime = this.$route.query.OrdersTime
    that.OrderTime = localStorage
      .getItem("kcdd")
      .replace("-", "/")
      .replace("-", "/");

    setTimeout(function() {
      that.countdown();
    }, 1000);
    //查看支付回调函数
    // // console.log(that.money)
    if (that.money == 0) {
      this.timer = setInterval(function() {
        that.OrderCallBack();
      }, 10);
    } else {
      this.timer = setInterval(function() {
        that.OrderCallBack();
      }, 10000);
    }
  }
};
</script>

<style scoped>
.bottombox {
  box-shadow: 0px 3px 5px 0px rgba(233, 233, 233, 0.5);
  position: relative;
  z-index: 9;
}

.hotgkt_bj {
  background: #fafafa;
  padding-top: 20px;
  padding-bottom: 110px;
}

.order_Steps {
  width: 1180px;
  height: 120px;
  background: #ffffff;
  border-radius: 12px;
  margin: 0 auto;
  margin-bottom: 16px;
}

.order_Steps .ul {
  width: 658px;
  height: 77px;
  padding-top: 22px;
  margin: 0 auto;
  display: -webkit-flex;
  justify-content: space-between;
  display: flex;
  position: relative;
}

.order_Steps .ul .li {
  display: inline-block;
  width: 110px;
  height: 16px;
  line-height: 16px;
  font-size: 16px;
  color: #999999;
  background: url(../../assets/publicClass/icon_JD-B.png) top no-repeat;
  text-align: center;
  padding-top: 61px;
  position: relative;
  z-index: 5;
}

.order_Steps .ul .li.side {
  background-image: url(../../assets/publicClass/icon_JD-A.png);
  color: #333333;
}

.order_Steps .ul .stepsT {
  width: 600px;
  height: 5px;
  background: #f6f6f6;
  border-radius: 3px;
  position: absolute;
  left: 29px;
  top: 65px;
  padding-top: 1px;
}

.order_Steps .ul .stepsT strong {
  display: block;
  width: 300px;
  height: 4px;
  background: #ff7e7e;
  border-radius: 3px;
}

.order_Steps .ul .stepsT strong span {
  width: 6px;
  height: 6px;
  background: #ff7e7e;
  border-radius: 3px;
  margin-top: -1px;
}

.order_Steps .ul .stepsT strong .left {
  margin-left: -1px;
}

.order_content {
  width: 1180px;
  height: 435px;
  background: #ffffff;
  border-radius: 12px;
  margin: 0 auto;
}

.order_xx {
  width: 1080px;
  padding-top: 35px;
  padding-bottom: 12px;
  border-bottom: 1px #d5d5d5 solid;
  margin: 0 auto;
  margin-bottom: 24px;
}

.order_xx h2 {
  font-size: 20px;
  color: #333;
  margin-bottom: 16px;
}

.order_xx .p1 {
  font-size: 14px;
  color: #333;
  margin-bottom: 16px;
}

.order_xx .p2 {
  font-size: 14px;
  color: #333;
  margin-bottom: 16px;
}

.order_xx .p2 span {
  color: #ff3953;
}

.order_xx .p3 {
  font-size: 16px;
  color: #ff3953;
  margin-bottom: 66px;
}

.order_xx .p4 {
  font-size: 14px;
  color: #333;
  text-align: left;
}

.order_zf {
  width: 1080px;
  margin: 0 auto;
}

.order_zf ul li {
  float: left;
  width: 300px;
  height: 88px;
  position: relative;
  overflow: hidden;
  margin-right: 32px;
  border-radius: 5px;
  box-shadow: 0 0 10px 6px rgba(245, 245, 245, 0.2);
  transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -webkit-transition: all 0.25s ease-in;
}

.order_zf ul li:hover,
.order_zf ul li.radio1 {
  box-shadow: 0 0 10px 6px rgba(245, 245, 245, 1);
}

.order_zf ul li .el-radio {
  display: block;
  width: 300px;
  height: 88px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 4;
  text-align: left;
  padding-left: 17px;
  padding-top: 36px;
  box-sizing: border-box;
}

.order_zf ul li img {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 5;
}

.pay_tan {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 460px;
  height: 560px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(102, 102, 102, 0.6);
  border-radius: 12px;
  margin-left: -230px;
  margin-top: -280px;
  box-sizing: border-box;
  z-index: 9;
  text-align: center;
}

.pay_tan .close {
  top: 20px;
  left: 20px;
  position: absolute;
  width: 36px;
  height: 36px;
  cursor: pointer;
  z-index: 8;
}

.pay_smzf {
  position: relative;
  padding-top: 67px;
}

.pay_smzf .close img {
  width: 100%;
}

.pay_smzf .p1 {
  font-size: 20px;
  color: #222;
  line-height: 20px;
  margin-bottom: 28px;
}

.pay_smzf .p2 {
  font-size: 14px;
  color: #666;
  margin-bottom: 28px;
  line-height: 14px;
}

.pay_smzf .p3 {
  margin-bottom: 16px;
}

.pay_smzf .p4 {
  width: 300px;
  height: 42px;
  background: #f5f6f6;
  border-radius: 48px;
  text-align: center;
  line-height: 42px;
  color: #666;
  font-size: 14px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/page2/publicClass/publicClass_pay.vue